<template>
  <v-container
      :fluid="true"
      fill-height
  >
    <v-form
        :model-value="valid"
        @update:model-value="$emit('update:valid', $event)"
    >
      <v-row>
        <v-spacer v-if="$vuetify.display.lgAndUp"/>
        <v-col md="12">
          <v-card
              color="grey-lighten-4"
              class="rounded pa-6 elevation-0"
          >
            <v-row>
              <v-col cols="12">
                <v-text-field
                    :clearable="true"
                    label="Username"
                    variant="outlined"
                    @update:model-value="$emit('update:username', $event)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                    :clearable="true"
                    label="Client name"
                    variant="outlined"
                    @update:model-value="$emit('update:name', $event)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                  cols="12"
                  md="6"
              >
                <v-row>
                  <v-col>
                    <v-text-field
                        :clearable="true"
                        :rules="amountRules"
                        type="number"
                        label="Balance from"
                        variant="outlined"
                        @update:model-value="$emit('update:balanceFrom', $event)"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                        :clearable="true"
                        :rules="amountRules"
                        type="number"
                        label="to"
                        variant="outlined"
                        @update:model-value="$emit('update:balanceTo', $event)"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                  cols="12"
                  md="6"
              >
                <v-select
                    :items="currencyOptions"
                    label="Select currency"
                    bg-color="grey-lighten-5"
                    @update:model-value="$emit('update:currency', $event)"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-spacer v-if="$vuetify.display.lgAndUp"/>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>

export default {
  name: "AccountantFilter",
  emits: ['update:username', 'update:name', 'update:balanceFrom', 'update:balanceTo', 'update:currency', 'update:valid'],
  props: {
    valid: Boolean,
    username: String,
    name: String,
    balanceFrom: String,
    balanceTo: String,
    currency: String,
    currencyOptions: Array
  },
  data() {
    return {
      amountRules: [
        v => !v || v > 0 || 'Amount must be positive',
      ]
    }
  }
}
</script>

<style scoped>

</style>